import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
    downloadPcapFileError,
    downloadPcapFileRequest,
    downloadPcapFileSuccess,
    getPcapFilesError,
    getPcapFilesRequest,
    getPcapFilesSuccess,
} from './index';
import { PayloadAction } from '@reduxjs/toolkit';
import { SagaIterator } from 'redux-saga';
import { AxiosError } from 'axios';
import { downloadPcapFile, getPcapFiles } from '../api/libraryApi';
import { PcapFile, PcapFilesSearchRequestParams } from '../types';

export function* getPcapFilesSaga(action: PayloadAction<PcapFilesSearchRequestParams>): SagaIterator {
    try {
        const response = yield call(getPcapFiles, action.payload);
        yield put(getPcapFilesSuccess(response));
    } catch (error) {
        yield put(getPcapFilesError(error as AxiosError));
    }
}

export function* downloadPcapFileSaga(action: PayloadAction<PcapFile['pk']>): SagaIterator {
    const pk = action.payload;

    try {
        const response = yield call(downloadPcapFile, pk);
        yield put(downloadPcapFileSuccess(response));
    } catch (error) {
        yield put(downloadPcapFileError(error as AxiosError));
    }
}

export default function* librarySagaWatcher() {
    yield all([
        takeLatest(getPcapFilesRequest, getPcapFilesSaga),
        takeLatest(downloadPcapFileRequest, downloadPcapFileSaga),
    ]);
}
